<template>
  <div class="hotelDetail">
    <loading v-if="isShowLoading"></loading>
    <div class="hotel_wrap"> 
       <div class=" width-1200">
        <Breadcrumb separator="＞">
          <BreadcrumbItem :to="{name: 'hotel'}">酒店住宿</BreadcrumbItem>
          <BreadcrumbItem >酒店详情</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="titInfo">
        <div class="titleft">
          <div class="title">
            <h1>{{hotelObj.hotelName}}</h1>
            <span v-if="hotelObj.hotelLevalEnum">{{hotelObj.hotelLevalEnum.name}}</span>
          </div>
          <div class="place">
            <span>地址：{{hotelObj.detailAddress}}</span>
            <span @click="gotoamap(hotelObj.id)"><i class="icon _place"></i> 查看地图</span>
          </div>
        </div>
        <div class="titright">
          <div class="price">¥ <span>{{hotelObj.lowerPrice}}</span> 起</div>
          <div class="phone"><i class="icon _phone"></i> 订房热线：{{hotelObj.bookingHotLine}}</div>
        </div>
        <div class="clearfix"></div>
      </div>
      <!-- 酒店图片展示 -->
      <div class="picArea">
        <div class="picAreaL">
          <div class="totalNum">{{totalPic}} 张图</div>
          <div class="introd">{{hotelObj.hotelIntroduce}}</div>
          <a><img :src="hotelObj.mainPic" alt="" @click="showModelPic(9999999)"></a>
        </div>
        <div class="picAreaR">
          <a v-for="(item,idx ) in picArrList"><img :src="item.upadder" :key="item.upid" @click="showModelPic(item.upid)" alt="" class="smallPic"></a>  
        </div>
        <div class="clearfix"></div>
      </div>
      <!-- 房型列表 -->
      <div class="bigtit"><span></span> 房型列表</div>
      <Table class="ticket-table" :columns="ticketColumn1" :data="plist" ></Table>
      <div class="bigtit"><span></span> 酒店介绍</div>
      <div class="introduct"> {{hotelObj.hotelIntroduce}}</div>
      <div class="bigtit"><span></span> 酒店设施</div>
      <div class="serve">
        <div class="tit"><i class="icon _wifi"></i>网络服务</div>
        <ul> <li><i class="icon ishas"></i> {{hotelObj.network}}</li></ul>
      </div>
      <div class="serve">
        <div class="tit"><i class="icon _parking"></i>停车场</div>
        <ul> <li><i class="icon ishas"></i> {{hotelObj.parking}}</li></ul>
      </div>
      <div class="serve">
        <div class="tit"><i class="icon _leisure"></i>休闲娱乐</div>
        <ul v-if="hotelObj.leisure">
           <li v-for="(item,idx) in hotelObj.leisure.split(':')" :key="idx"><i class="icon ishas"></i> {{item}}</li>
        </ul>
      </div>
      <div class="serve">
        <div class="tit"><i class="icon _food"></i>餐饮服务</div>
        <ul v-if="hotelObj.foodAndBeverage">
          <li v-for="(item,idx) in hotelObj.foodAndBeverage.split(':')" :key="idx"><i class="icon ishas"></i> {{item}}</li>
        </ul>
      </div>
      <div class="serve">
        <div class="tit"><i class="icon _business"></i>商务服务</div>
        <ul v-if="hotelObj.business">
          <li v-for="(item,idx) in hotelObj.business.split(':')" :key="idx"><i class="icon ishas"></i> {{item}}</li>
        </ul>
      </div>
      <div class="serve">
        <div class="tit"><i class="icon _service"></i>前台服务</div>
        <ul v-if=" hotelObj.frontDesk">
          <li v-for="(item,idx) in hotelObj.frontDesk.split(':')" :key="idx"><i class="icon ishas"></i> {{item}}</li>
        </ul>
      </div>
      <div class="bigtit"><span></span> 补充说明</div>
      <div>{{hotelObj.instructions}}</div>
    </div>
  <detail-hotel :ishotelDetail="ishotelDetail"  v-on:ishotelDetailfn="ishotelDetailfn" :roomsObj="roomsObj"></detail-hotel>
  <model-pic :ismodelPic="ismodelPic"  v-on:ismodelPicFn="ismodelPicFn" :allPicArr="allPicArr" :clickId="clickId"></model-pic>

  </div>
</template>

<script>
import detailHotel from './model_hotel'
import modelPic from './model_pic'
export default {
  components: {
    detailHotel,
    modelPic
  },
  data () {
    let that = this;
    return {
      token: sessionStorage.getItem("name"),
      allPicArr: [],//所有图片集合
      clickId: 0,//点击当前图片下标
      picArrList: [],//右边栏小图片
      totalPic: 0,//图片张数
      facilityArr: [],//酒店设施
      roomsObj: {},//当前房型详情信息
      hotelObj: {},
      isShowLoading: false,
      ishotelDetail: false,
      ismodelPic: false,
      ticketColumn1: [
        {
          title: '缩略图',
          align: 'center',
          render: (h, params) => {
            return h('div', { style: { padding: '10px 0', } },
              [
                h('img', {
                  attrs: {
                    src: JSON.parse(params.row.roomPic)[0].response.data.info.url
                  },
                  style: { width: '119px', height: '93px', }
                }),
              ]);
          }
        },
        {
          title: '房型',
          align: 'center',
          render: (h, params) => {
            return h('span', { style: { marginLeft: '5px', fontSize: '14px', color: '#4B7FF0' } }, params.row.roomName);
          }
        },
        {
          title: '床型',
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.bedType === 2 ? '双人床' : '单人床')
          }
        },
        {
          title: '操作',
          key: '',
          align: 'center',
          render: function (h, params) {
            return h('div', {
              on: {
                click: () => {
                  that.roomsObj = params.row
                  that.ishotelDetail = true;
                }
              }
            }, [
                h('a', '详情'),
              ])
          },

        },
        {
          title: '房价',
          align: 'center',
          render: (h, params) => {
            return h('div', {
              style: {
                padding: '10px 0',
              }
            }, [
                h('span', {
                  style: {
                    fontSize: '14px',
                    color: '#FC8625',
                    verticalAlign: 'middle'
                  }
                }, `￥`),
                h('span', {
                  style: {
                    fontSize: '24px',
                    color: '#FC8625',
                    verticalAlign: 'middle'
                  }
                }, `${params.row.salePrice}/晚`)
              ]);
          }
        },
      ],
      plist: []//房型列表
    }
  },

  mounted () {
    this.getHotelDetail()
  },
  methods: {
    /** * 获取酒店详情信息 * **/
    getHotelDetail () {
      this.isShowLoading = true;
      let id = this.$route.params.Id;
      let queryUrl = `${this.baseURL}/sys/hotel/v1/shop/${id}`
      queryUrl += '?' + this.QS.stringify({
        // access_token: this.token,
      })
      this.$http.get(queryUrl).then(res => {
        let Data = res.data;
        if (Data.code === 200) {
          this.isShowLoading = false;
          this.hotelObj = Data.data;
          console.log(Data.data)
          //酒店图片展示区数据
          let apperancePic = JSON.parse(this.hotelObj.apperancePic);
          let internalPic = JSON.parse(this.hotelObj.internalPic);
          let allpic = apperancePic.concat(internalPic);
          let picArr = [];
          //酒店图片
          this.totalPic = apperancePic.length + internalPic.length + 1;
          apperancePic.map((item, idx) => { if (idx < 3) picArr.push(item) });
          internalPic.map((item, idx) => { if (idx < 3) picArr.push(item) });
          picArr.map((picitem, picIdx) => { this.picArrList.push({ upid: picitem.response.data.upid, upadder: picitem.response.data.info.url }) });
          //酒店图片弹窗图片
          allpic.map((item, index) => {
            this.allPicArr.push({
              upid: item.response.data.upid,
              upadder: item.response.data.info.url
            })
          })
          //添加弹窗酒店主图
          this.allPicArr.unshift({
            upid: 9999999,
            upadder: Data.data.mainPic
          });

          //酒店设施
          // console.log(22222, Data.data)

          // 房型列表
          Data.data.rooms.map((item, idx) => {
            item.tit = Data.data.hotelName;
            this.plist.push(item)
          })
        }
      })
    },

    /**跳转到地图**/
    gotoamap (id) {
      this.$router.push({
        name: 'amap',
        Id: id
      })
    },
    /**
     * 景区门票翻页函数   access_token: this.token,
     **/
    async changePage (num) {
      this.page.page = num;
      window.scrollTo(0, 0);
    },
    ishotelDetailfn (TF) {
      this.ishotelDetail = TF;
    },
    ismodelPicFn (TF) {
      this.ismodelPic = TF
    },
    showModelPic (id) {
      this.clickId = id
      this.ismodelPic = true;
    }

  }
}
</script>
<style lang="less" scoped>
.hotelDetail {
  .icon {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 25px;
    // border: 1px solid #eee;
  }
  ._phone {
    background: url("./img/phone.svg") no-repeat 1px 3px;
  }
  .ishas {
    background: url("./img/finish-1.svg") no-repeat center;
  }
  ._wifi {
    background: url("./img/wifi.svg") no-repeat center;
  }
  ._parking {
    background: url("./img/parking.svg") no-repeat center;
  }
  ._leisure {
    background: url("./img/leisure.svg") no-repeat center;
  }
  ._food {
    background: url("./img/food.svg") no-repeat center;
  }
  ._business {
    background: url("./img/Business.svg") no-repeat center;
  }
  ._service {
    background: url("./img/service.svg") no-repeat center;
  }
  .bigtit {
    margin-top: 40px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
    letter-spacing: 0;
    padding-bottom: 10px;
    border-bottom: 1px dashed #d9dbde;
    span {
      display: inline-block;
      width: 4px;
      background: #2e70ff;
      height: 25px;
      vertical-align: middle;
      margin-right: 8px;
    }
  }
  background-color: #fff;

  .hotel_wrap {
    width: 1200px;
    margin: 0 auto;
    .titInfo {
      .titleft {
        float: left;
        width: 897px;
        border-right: 1px solid #cfc7c7;
        .title {
          margin-bottom: 22px;
          h1 {
            display: inline;
            font-size: 24px;
            color: #323233;
            letter-spacing: 0;
          }
          span {
            border: 1px solid #4b7ff0;
            padding: 3px 7px;
            margin-left: 11px;
            color: #4b7ff0;
            border-radius: 5px;
          }
        }
        .place {
          letter-spacing: 0;
          font-size: 14px;
          span:nth-child(1) {
            color: #323233;
          }
          span:nth-child(2) {
            cursor: pointer;
            margin-left: 24px;
            color: #2e70ff;
            ._place {
              background: url("./img/place_blue.svg") no-repeat 5px 2px;
              margin-right: 0px;
            }
          }
        }
      }
      .titright {
        float: right;
        width: 302px;
        text-align: center;
        font-size: 14px;
        .price {
          color: #2e70ff;
          letter-spacing: 0;
          span {
            font-size: 28px;
          }
        }
        .phone {
          color: #323233;
        }
      }
    }
    .picArea {
      margin-top: 27px;
      .picAreaL {
        border-radius: 5px;
        float: left;
        width: 820px;
        height: 450px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        position: relative;
        img {
          border-radius: 5px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .totalNum {
          position: absolute;
          width: 107px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 5px;
          top: 12px;
          right: 0;
          margin-right: 28px;
        }
        .introd {
          position: absolute;
          padding: 15px;
          box-sizing: border-box;
          width: 283px;
          // height: 112px;
          font-size: 14px;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 5px;
          left: 26px;
          bottom: 26px;
          margin-right: 28px;
        }
      }
      .picAreaR {
        float: right;
        overflow: hidden;
        width: 378px;
        .smallPic {
          border-radius: 5px;
          width: 182px;
          height: 144px;
          margin-left: 7px;
          margin-bottom: 8px;
          float: left;
        }
      }
    }
    .clearfix {
      display: block;
      content: " ";
      overflow: hidden;
      clear: both;
    }
    .introduct {
      font-size: 14px;
      color: #323233;
    }
    .serve {
      font-size: 14px;
      color: #323233;
      padding-bottom: 20px;
      margin-bottom: 16px;
      border-bottom: 1px dashed #d9dbde;
      .tit {
        margin-bottom: 20px;
      }
      ul {
        // overflow: hidden;
        padding-left: 20px;
        &:after {
          display: block;
          content: " ";
          // overflow: hidden;
          clear: both;
        }
        li {
          float: left;
          margin-right: 50px;
        }
      }
    }
  }
}
</style>

<style lang="less">
</style>
